(function () {
    angular.module('directives').directive('hInfiniteScroll', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            scope: {
                onReachBottom: '&onReachBottom',
                name: "@",
                isWindow: "=",
                threshold: "="
            },
            link: function (scope, elm, attr) {
                var target = scope.isWindow ? window : elm;
                var $target = $(target);
                var locked = false;
                var threshold = scope.threshold ? parseInt(scope.threshold) : 300;
                var scrollTimer = null;
                angular.element(target).bind('scroll.' + scope.name, function () {
                    if (locked) {
                        return;
                    }
                    locked = true;

                    $timeout.cancel(scrollTimer);

                    scrollTimer = $timeout(function () {
                        if (target === window) {
                            if ($(document).height() - threshold <= $target.height() + $target.scrollTop()) {
                                if (scope.onReachBottom) {
                                    scope.onReachBottom();
                                }
                            }
                        } else {
                            if ($target.prop('scrollHeight') - threshold <= $target.height() + $target.scrollTop()) {
                                if (scope.onReachBottom) {
                                    scope.onReachBottom();
                                }
                            }
                        }

                        locked = false;
                    }, 100);
                });

                scope.$on('$destroy', function () {
                    if (scope.name) {
                        angular.element(target).off("scroll." + scope.name);
                    }
                    $timeout.cancel(scrollTimer);
                });
            }
        }
    }]);
})();